module.exports = function (orderTrackerService, shopLocatorService, $anchorScroll) {
    return {
        restrict: 'E',
        scope: {
        },
        link(scope) {
            scope.orderTracker = orderTrackerService;

            function getStatusText(status, bookingStatus, isBackorder) {

                let text = {};
                scope.showTrackingLink = bookingStatus === 'WithDriver';

                const collectionText = isBackorder ? 'to be picked up by ' : ' around ';

                if (orderTrackerService.lastOrder.DeliveryMethod === 'Pickup') {
                    if (status === 'Placed') {

                        text = {
                            title: `We're on it!`,
                            body:
                            (isBackorder ?
                            `Your order is being packed by <span class='strong-primary color-primary'>  BWS ${scope.orderTracker.lastOrder.PickUpStoreName} </span> and should be ready ${collectionText}`
                            :
                            `Your order will be packed by <span class='strong-primary color-primary'>  BWS ${scope.orderTracker.lastOrder.PickUpStoreName} </span>. We’ll send you a text as a reminder, but your order should be ready before `)
                        };


                    } else if (status === 'Packed') {

                        text = {
                            title: 'Come & Get it!',
                            body: `Your order is ready to pick up from <span class='strong-primary color-primary'> BWS ${scope.orderTracker.lastOrder.PickUpStoreName} </span>. Don\'t forget to bring photo ID; we\'ll need to record some details. `
                        };

                    }
                } else if (orderTrackerService.lastOrder.DeliveryMethod === 'Delivery') {

                    if (status === 'Placed') {

                        text = {
                            title: `We're on it!`,
                            body: `<span class='strong-primary color-primary'>BWS ${scope.orderTracker.lastOrder.PickUpStoreName}</span> is packing your order now. Delivery has been requested for`
                        };

                    } else if (bookingStatus === 'DeliveryRequested') {
                        text = {
                            title: `We're on it!`,
                            body: `We're just awaiting a driver to pick up your order from BWS <span class='strong-primary color-primary'>${scope.orderTracker.lastOrder.PickUpStoreName}</span>. Delivery has been requested for`
                        };
                    } else if (bookingStatus === 'DriverAssigned') {
                        text = {
                            title: 'Driver Booked!',
                            body: `A driver is on the way to pick up your order. A text will be sent once the driver is heading your way Your delivery is scheduled for`
                        };
                    } else if (bookingStatus === 'WithDriver' || bookingStatus === 'AtCustomer') {
                        text = {
                            title: `It's On The Way!`,
                            body: `Our driver is on the way, track your order via the link below. Your delivery is scheduled for`
                        };
                    }
                }

                return text;
            }


            function getPreOrderStatusText() {

                let text = {};

                if (orderTrackerService.lastOrder.DeliveryMethod === 'Pickup') {
                    text = {
                        title: 'Stay tuned!',
                        body: `Your pre-order will be packed by <span class='strong-primary color-primary'> BWS ${scope.orderTracker.lastOrder.PickUpStoreName} </span>. We'll send you a text as a reminder, but it should be ready to collect from: <br/> `
                    };
                } else if (orderTrackerService.lastOrder.DeliveryMethod === 'Delivery') {
                    text = {
                        title: 'Stay tuned!',
                        body: `Your pre-order will be packed by <span class='strong-primary color-primary'> BWS ${scope.orderTracker.lastOrder.PickUpStoreName} </span>. We'll send you a text as a reminder once it's ready. You have requested delivery for `
                    };
                }

                return text;
            }

            scope.getStoreInfoUrlParams = function () {
                return shopLocatorService.generateUrlParamsForStoreInfos(scope.storePicker.store);
            };

            scope.$watch('orderTracker.lastOrder.Status', function (status) {
                if (status) {
                    const bookingStatus = scope.orderTracker.lastOrder.DeliveryBookingList.length
                                          ? scope.orderTracker.lastOrder.DeliveryBookingList[0].BookingStatus
                                          : null;

                    scope.statusText = scope.orderTracker.lastOrder.PreOrder ?
                        getPreOrderStatusText() : getStatusText(status, bookingStatus, scope.orderTracker.lastOrder.BackOrder);

                }
            }, true);

            scope.$watch('orderTracker.isOpen', (newValue) => {
                if (typeof newValue !== 'undefined' && newValue === true) {
                    $anchorScroll('body-container');
                }
            });
        },
        template: require('./order-tracker-template.html')
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/order-tracker/order-tracker-directive.js
 **/